import axios from "axios";

/**
 * Configuration centralisée de l'API
 * Backend sur port 3001
 */
const getApiUrl = (): string => {
  // Variable d'environnement personnalisée (priorité)
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // En développement - proxy via vite vers le backend
  if (import.meta.env.DEV) {
    return "/api";
  }

  // Production - nginx proxy vers backend
  return "/api";
};

export const API_URL = getApiUrl();

// Instance axios pré-configurée
export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

// Intercepteur pour gérer les erreurs de réponse
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (import.meta.env.DEV) {
      if (error.response) {
        console.error(`[API] Erreur ${error.response.status}:`, error.response.data);
      } else if (error.request) {
        console.error("[API] Pas de réponse du serveur");
      }
    }
    return Promise.reject(error);
  }
);

export default API_URL;
